import { render, staticRenderFns } from "./LinkGueno.vue?vue&type=template&id=a370a5c8"
import script from "./LinkGueno.vue?vue&type=script&lang=js"
export * from "./LinkGueno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports